export default "__VITE_ASSET__B80cnsxd__"